import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import MapView from 'react-native-map-clustering';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

import {ScrollView} from 'react-native-gesture-handler';

interface ISelectFilter {
  selected?: boolean;
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

//@ts-ignore
export const Map = styled(MapView)`
  background: ${({theme}) => theme.colors.green_light};
  height: 100%;
`;

//@ts-ignore
export const MarkerView = styled(FastImage)`
  width: ${RFValue(40)}px;
  height: ${RFValue(40)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(10)}px;
`;

export const MapHeader = styled.View`
  padding: 0 24px;
  margin-top: ${!getBottomSpace() ? RFValue(20) : RFValue(12)}px;
  position: absolute;
  z-index: 2;
  width: 100%;
`;
export const Form = styled.View``;

export const NeastedStation = styled.View`
  margin-top: ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background_secondary};
  padding: ${RFValue(16)}px 24px;
  border-radius: ${RFValue(12)}px;
`;

export const NeastedStationTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const StationContainer = styled.View`
  margin-top: ${RFValue(6)}px;
`;

export const Station = styled.TouchableOpacity`
  margin-top: ${RFValue(12)}px;
`;

export const StationContent = styled.View`
  flex-direction: row;
  align-items: center;

  justify-content: space-between;
`;

export const StationColumn = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

//@ts-ignore
export const StationImage = styled(FastImage)`
  height: ${RFValue(50)}px;
  width: ${RFValue(50)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
`;
export const StationInfos = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;

export const StationName = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const StationDetails = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const StationAddress = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const Distance = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const NeastedStationContainer = styled.View`
  flex-direction: column;
  flex:1;
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  padding-bottom: ${RFValue(6)}px;
`;

export const NeastedStationHeader = styled.View`
  flex-direction: row;
  align-items: center;
  
  justify-content: space-between;

  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};


`;
export const NeastedStationButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
`;

export const NeastedStationButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const SelectedCity = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
`;


export const FiltersContainer = styled.View`
  margin: 0 -24px;
  margin-top: ${RFValue(8)}px;
  margin-bottom: -${RFValue(14)}px;
`;

//@ts-ignore
export const ButtonsCategory = styled(ScrollView).attrs({
  horizontal: true,
  showsHorizontalScrollIndicator: false,
  contentContainerStyle: {paddingRight: 18, paddingLeft: 24},
})`
  width: 100%;
  height: ${RFValue(38)}px;
  flex-direction: row;
`;

export const ButtonCategory = styled.TouchableOpacity<ISelectFilter>`
  align-items: center;
  justify-content: center;
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  height: ${RFValue(28)}px;

  margin-right: ${RFValue(6)}px;

  border-radius: 30px;
  background-color: ${props =>
    props.selected
      ? props.theme.colors.primary
      : props.theme.colors.input_search};
`;
export const ButtonCategoryText = styled.Text<ISelectFilter>`
  color: ${props =>
    props.selected ? props.theme.colors.shape : props.theme.colors.text_dark};
  font-family: ${props =>
    props.selected ? props.theme.fonts.semibold : props.theme.fonts.regular};
`;



export const CalloutContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: 12px;
  padding: 10px;
  width: 240px;

  /* Sombra no iOS */
  shadow-color: #222;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.3;
  shadow-radius: 5px;

  /* Elevação no Android */
  elevation: 5;
`;

export const CalloutText = styled.Text`
  color:${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  margin-bottom: 2px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const CalloutSubtext = styled.Text`
  color:${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  margin-bottom: 2px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const CalloutButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.primary};
  border-radius: 8px;
  margin-top: ${RFValue(8)}px;
  padding: 8px 12px;
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  align-items: center;
  justify-content: center;
`;

export const CalloutButtonText = styled.Text`
  color: #fff;
  font-size: ${RFValue(10)}px;
  font-weight: 600;
`;

export const CalloutInfosContainer = styled.View`
  flex-direction: row;
  align-items: flex-start;

  gap: ${RFValue(6)}px;
`;

//@ts-ignore
export const CalloutAvatar = styled(FastImage)`
    height: ${RFValue(40)}px;
  width: ${RFValue(40)}px;
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(8)}px;
`;
export const CalloutInfos = styled.View`
  flex:1;
`;
export const OpenMapIcons = styled.View`
  flex-direction: row;
  align-items: flex-start;
`;

export const MapIcon = styled.Image`
  width: ${RFValue(41)}px;
  border-radius: 30px;
  height: ${RFValue(41)}px;
`;

export const MapTitle = styled.Text`
  font-size: ${RFValue(9)}px;
  text-align: center;
  margin-top: 6px;
  line-height: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const OpenMapsTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  margin-bottom: ${RFValue(8)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const LinkButtonContainer = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${RFValue(4)}px;
`;

export const LocationPill = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${({theme}) => theme.colors.background_secondary};
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(7)}px ${RFValue(14)}px;
  margin-top: ${RFValue(8)}px;
`;
